<div class="logo">
    <div [ngClass]="['bg dragon', className]"></div>
    <p>Press Space to start</p>
</div>